import { combineReducers } from 'redux';
import registerList from '../screens/RegisterList/reducers';
import personalConfirm from '../screens/PersonalConfirm/reducers';
import registerConfirm from '../screens/RegisterConfirm/reducers';
import personalCreation from '../screens/PersonalCreation/reducers';
import paramReducer from './paramReducer';
import fieldSettingsReducer from './fieldSettingsReducer';
import verifyReducer from './verifyReducer';
import uploadReducer from './uploadReducer';
export default combineReducers({
  personalCreation,
  registerList,
  personalConfirm,
  registerConfirm,
  paramReducer,
  fieldSettingsReducer,
  verifyReducer,
  uploadReducer,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Hire/reducers/index.js
 **/